module.exports = __webpack_public_path__ + "static/media/cover.bef97dc5.webp";